import { HttpInterceptorFn } from '@angular/common/http';
import { authHttpInterceptorFn } from "@auth0/auth0-angular";
import { SKIP_AUTH } from "./custom-auth-interceptor.context";

export const customAuthInterceptorFn: HttpInterceptorFn = (req, next) => {
  
  // 👉 Si dans le HttpContext d'une requête on a le flag SKIP_AUTH (via le withSkipAuth context), on ne fait pas d'authentification
  if (req.context.has(SKIP_AUTH)) {
    return next(req);
  }
  
  // 👉 sinon comportement normal Auth0
  return authHttpInterceptorFn(req, next);
};
